import React from 'react';
import ad1 from '../../../assets/ad1.png';
import ad2 from '../../../assets/ad2.png';
import ad3 from '../../../assets/ad3.png';
import {Helmet} from "react-helmet";


const MotionGraphics = () => {
    return (
        <div className="grid sm:grid-cols-1 lg:grid-cols-3 md:grid-cols-2 gap-4 lg:mt-6 mt-4 items-center">
        <Helmet>
        <title>MotionGraphics project</title>
        <meta name='portfolio' content='Mahabuba akter morsana - Video ad, Animation project' />
        </Helmet>
        <div class="max-w-sm bg-gray-800 rounded-lg shadow transition duration-300 transform border border-[#976db2] hover:scale-105 group hover:shadow-xl">
     <a href="https://www.behance.net/gallery/172024555/Social-Media-Post-and-Video-Advertising" target="_blank" rel="noreferrer">
         <img class="rounded-t-lg" src={ad1} alt="" />
     </a>
     <div class="p-5">
         <p class="mb-3 font-normal text-gray-400">Social Media Ad</p>
                  <a href="https://www.behance.net/gallery/172024555/Social-Media-Post-and-Video-Advertising" target="_blank" rel="noreferrer" type="button" class="text-white bg-gradient-to-r from-purple-500 via-purple-600 to-[#976DB2] hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-purple-300 shadow-md shadow-purple-400/40 font-medium rounded-lg text-sm px-5 py-2.5 text-center mr-2 mb-2">READ MORE</a>
     </div>
        </div>
        <div class="max-w-sm bg-gray-800 rounded-lg shadow transition duration-300 transform border border-[#976db2] hover:scale-105 group hover:shadow-xl">
     <a href="https://www.behance.net/gallery/172441637/2D-Car-Animation?share=1" target="_blank" rel="noreferrer">
         <img class="rounded-t-lg" src={ad2} alt="" />
     </a>
     <div class="p-5">
         <p class="mb-3 font-normal text-gray-400">Car Animation</p>
                  <a href="https://www.behance.net/gallery/172441637/2D-Car-Animation?share=1" type="button" class="text-white bg-gradient-to-r from-purple-500 via-purple-600 to-[#976DB2] hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-purple-300 shadow-md shadow-purple-400/40 font-medium rounded-lg text-sm px-5 py-2.5 text-center mr-2 mb-2" target="_blank" rel="noreferrer">READ MORE</a>
     </div>
        </div>
        
        <div class="max-w-sm bg-gray-800 rounded-lg shadow transition duration-300 transform border border-[#976db2] hover:scale-105 group hover:shadow-xl">
     <a href="https://www.behance.net/gallery/171986037/Medical-Health-Social-Media-PostAd-Design" target="_blank" rel="noreferrer">
         <img class="rounded-t-lg" src={ad3} alt="" />
     </a>
     <div class="p-5">
         <p class="mb-3 font-normal text-gray-400">Social Media Ad</p>
                  <a href="https://www.behance.net/gallery/171986037/Medical-Health-Social-Media-PostAd-Design" target="_blank" rel="noreferrer" type="button" class="text-white bg-gradient-to-r from-purple-500 via-purple-600 to-[#976DB2] hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-purple-300 shadow-md shadow-purple-400/40 font-medium rounded-lg text-sm px-5 py-2.5 text-center mr-2 mb-2">READ MORE</a>
     </div>
        </div>
        </div>
    );
};

export default MotionGraphics;